module.exports = __webpack_public_path__ + "static/media/12.1a725816.png";